import React from "react";
import { CardBase } from "./partials/CardBase";
import { CardWrapper } from "./partials/CardWrapper";
export const PlaylistCard = (props) => {
    const { options, isLiked, toggleFavourite } = props;
    return (React.createElement(CardWrapper, null,
        React.createElement(CardBase, { imageUrl: options.imageUrl, title: options.title, link: `/playlist/${options.id}`, toggleFavourite: toggleFavourite ? () => toggleFavourite({ playlistId: options.id }) : null, isLiked: isLiked })));
};
//# sourceMappingURL=PlaylistCard.js.map